var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1875 15.9413H22.6023V22.3561H16.1875V15.9413ZM25.1682 4.39462H23.8853V1.8287H21.3193V4.39462H11.0557V1.8287H8.48975V4.39462H7.20679C5.79553 4.39462 4.64087 5.54929 4.64087 6.96054V24.922C4.64087 26.3332 5.79553 27.4879 7.20679 27.4879H25.1682C26.5795 27.4879 27.7341 26.3332 27.7341 24.922V6.96054C27.7341 5.54929 26.5795 4.39462 25.1682 4.39462ZM25.1682 6.96054V9.52646H7.20679V6.96054H25.1682ZM7.20679 24.922V12.0924H25.1682V24.922H7.20679Z",
    fill: "#3D64E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDob);
export default __webpack_public_path__ + "static/media/dob.405a6c4be89f818dff5d509d33ecb38a.svg";
export { ForwardRef as ReactComponent };